"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderOrderStatus = void 0;
const renderOrderStatus = (status) => {
    let config = {
        color: "bg-blue",
        text_color: "text-white",
        text_only_color: "blue",
        text: "",
    };
    switch (status) {
        case "RATE_REQUESTED":
            config = {
                color: "bg-red",
                text_color: "text-white",
                text_only_color: "red",
                text: "Rate Req",
            };
            break;
        case "CHANGE_REQUESTED":
            config = {
                color: "bg-red",
                text_color: "text-white",
                text_only_color: "red",
                text: "Change Req",
            };
            break;
        case "DRAFT":
            config = {
                color: "bg-grey3",
                text_color: "text-black",
                text_only_color: "grey6",
                text: "Draft",
            };
            break;
        case "QUOTE_SENT":
            config = {
                color: "bg-blue",
                text_color: "text-white",
                text_only_color: "blue",
                text: "Quote (Sent)",
            };
            break;
        case "QUOTE_EXPIRED":
            config = {
                color: "bg-grey3",
                text_color: "text-black",
                text_only_color: "grey3",
                text: "Quote (Expired)",
            };
            break;
        case "QUOTE_CANCELLED":
            config = {
                color: "bg-grey3",
                text_color: "text-black",
                text_only_color: "grey3",
                text: "Quote (Cancelled)",
            };
            break;
        case "READY_FOR_WORKFLOW":
            config = {
                color: "bg-green",
                text_color: "text-white",
                text_only_color: "green",
                text: "Ready for WF",
            };
            break;
        case "WAITING_FOR_DEPOSIT":
            config = {
                color: "bg-darkorange",
                text_color: "text-white",
                text_only_color: "darkorange",
                text: "Waiting for Deposit",
            };
            break;
        case "CONFIRMING_GOLF":
            config = {
                color: "bg-orange",
                text_color: "text-white",
                text_only_color: "orange",
                text: "Confirming Golf",
            };
            break;
        case "CONFIRMING_ALL":
            config = {
                color: "bg-orange",
                text_color: "text-white",
                text_only_color: "orange",
                text: "Confirming All",
            };
            break;
        case "WAITING_FOR_BALANCE":
            config = {
                color: "bg-darkorange",
                text_color: "text-white",
                text_only_color: "darkorange",
                text: "Waiting for Balance",
            };
            break;
        case "WAITING_FOR_PAYMENT":
            config = {
                color: "bg-darkorange",
                text_color: "text-white",
                text_only_color: "darkorange",
                text: "Waiting for Payment",
            };
            break;
        case "PAYMENT_OVERDUE":
            config = {
                color: "bg-red",
                text_color: "text-white",
                text_only_color: "red",
                text: "Payment Overdue",
            };
            break;
        case "CONFIRMED":
            config = {
                color: "bg-green",
                text_color: "text-white",
                text_only_color: "green",
                text: "In Progress",
            };
            break;
        case "COMPLETE":
            config = {
                color: "bg-green",
                text_color: "text-white",
                text_only_color: "green",
                text: "Complete",
            };
            break;
        case "CANCELLED":
            config = {
                color: "bg-grey3",
                text_color: "text-black",
                text_only_color: "grey3",
                text: "Cancelled",
            };
            break;
        case "CANCELLED_UNPAID":
            config = {
                color: "bg-grey3",
                text_color: "text-black",
                text_only_color: "grey3",
                text: "Cancelled (Unpaid)",
            };
            break;
        case "ADDED_TO_OLD_SYSTEM":
            config = {
                color: "bg-lightgreen",
                text_color: "text-white",
                text_only_color: "lightgreen",
                text: "Added to Old Sys",
            };
            break;
        case "CALLBACK_REQUESTED":
            config = {
                color: "bg-pink",
                text_color: "text-white",
                text_only_color: "pink",
                text: "Callback Req",
            };
            break;
        default:
            config = {
                color: "bg-grey3",
                text_color: "text-black",
                text_only_color: "grey3",
                text: status
                    .toLowerCase()
                    .split("_")
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(" "),
            };
    }
    return config;
};
exports.renderOrderStatus = renderOrderStatus;
